import { styled as o, ButtonBase as i } from "@mui/material";
import n from "../../../assets/icons/icon-cross.svg.js";
import s from "../next/Image.js";
import { DEFAULT_ANIMATE_DURATION as t } from "../../../constants/layout.js";
import { jsx as r } from "react/jsx-runtime";
const m = o(i)`
  aspect-ratio: 1;
  width: 32px;
`, f = o(s)`
  transition: stroke ${t}ms,
    fill ${t}ms;
  filter: invert(76%);
  height: 100%;
  width: 100%;
  :hover {
    filter: invert(83%);
  }
  :active {
    filter: invert(88%);
  }
`, d = (e) => /* @__PURE__ */ r(m, {
  ...e,
  children: /* @__PURE__ */ r(f, {
    src: n
  })
});
export {
  d as default
};
//# sourceMappingURL=ApeironCloseButton.js.map
